import React, { FC, ReactNode } from "react";
import { Box } from "@mui/material";
import Topbar from "../../Navigation/Topbar";

interface AuthRightSidePanelProps {
  children: ReactNode;
}

const AuthRightSidePanel: FC<AuthRightSidePanelProps> = ({ children }) => {
  return (
    <Box
      sx={{
        flex: 1,
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        backgroundColor: "background.default",
        position: "relative"
      }}
    >
      <Topbar isAuthFlow />
      {children}
    </Box>
  );
};

export default AuthRightSidePanel;
